import { Box, Text } from '@chakra-ui/react';
import EmailGroup from 'components/common/fields/EmailGroup';
import PublishTag from 'components/common/fields/PublishTag';

export default [
  {
    name: 'Id',
    selector: (row) => row.id,
    sortable: true,
    width: '60px',
    sortField: 'id',
  },
  {
    name: 'Name',
    selector: (row) => row.name,
    sortable: true,
    cell: (row) => (
      <Text fontWeight={500} as="i">
        {row.name}
      </Text>
    ),
    sortField: 'name',
  },
  {
    name: 'Description',
    selector: (row) => row.description,
    wrap: true,
    sortable: true,
    format: (row) => (
      <Text py={2}>
        {row.description.length > 200
          ? `${row.description.slice(0, 200)}...`
          : row.description}
      </Text>
    ),

    sortField: 'description',
  },
  {
    name: 'Owner',
    selector: (row) => row.owner.name,
    sortable: true,
    cell: (row) => (
      <Box py={2}>
        <Text fontWeight={500} mb={2}>
          {row.owner?.name || 'N/A'}
        </Text>
        <EmailGroup name="Owner Groups:" emails={row.ownerGroups} />
      </Box>
    ),
    sortField: 'owner',
  },
  {
    name: 'Status',
    selector: (row) => row.isPublished,
    sortable: true,
    cell: (row) => <PublishTag isPublished={row.isPublished} />,
    sortField: 'isPublished',
  },
];
